// shade/production relationship
export const sunValues = {
  sunny: 1500,
  littleShade: 1200,
  lotOfShade: 1000,
};
